import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { CourseInput } from './CourseInput';
import type { Course } from '../../types/grades';

interface SortableCourseProps {
  id: string;
  course: Course;
  index: number;
  onChange: (updatedCourse: Course) => void;
  onDelete: () => void;
}

export function SortableCourse({ id, course, index, onChange, onDelete }: SortableCourseProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    position: 'relative' as const,
    zIndex: isDragging ? 999 : 'auto',
  };

  return (
    <CourseInput
      course={course}
      onChange={onChange}
      onDelete={onDelete}
      index={index}
      setNodeRef={setNodeRef}
      attributes={attributes}
      listeners={listeners}
      style={style}
      isDragging={isDragging}
    />
  );
}